import React, { useState, useEffect, useRef } from 'react';
import '../view-archer-styles.css';

//material UI
import { Breadcrumbs, Chip, Link, Stack,Typography } from '@mui/material/';
import { green, pink, blue, red } from '@mui/material/colors';
import { Drafts, Email } from '@mui/icons-material/';
import {NavigateNext} from '@mui/icons-material/';

interface Path {
    name: string;
    status: string;
    type: string;
}

interface Props {
    paths: Path[],
    linkFilerHome: ()=>void
    linkLetterEditor: ()=>void,
    linkIssueEditor:()=>void,
    linkFilerResponses: () => void
    linkFilerRefundTracker: ()=>void
}

const displayLetterStatusIcon = (status: string) => {
    switch (status) {
        case 'Draft':
            return (
                <Drafts fontSize="small" sx={{ color: '#ffc107'}} />
            );
        case 'Sent':
            return (
                <Email fontSize="small" sx={{ color: green[500]}} />
            );
        default:
            return '';
    }
};

const displayIssueStatusIcon = (status: string) => {
    switch (status) {
        case 'Delinquent':
            return (
                <Chip label="Delinquent" variant="outlined" size="small" color="error" />
            );
        case 'Outstanding':
            return (
                <Chip label="Outstanding" variant="outlined" size="small" color="error" />
            );
        case 'Held':
            return (
                <Chip variant="outlined" label={status} size="small" color="primary" />
            );
        case 'No Response Required':
            return (
                <Chip variant="outlined" label={status} size="small" color="success" />
            );
        case 'Punted':
            return (
                <Chip variant="outlined" label={status} size="small" color="primary" />
            );
        case 'Referred':
            return (
                <Chip variant="outlined" label={status} size="small" color="success" />
            );
        case 'Resolved':
            return (
                <Chip variant="outlined" label={status} size="small" color="success" />
            );
        case 'Draft':
            return (
                <Chip label="Draft" size="small" sx={{ bgcolor: '#ffc107', color: 'black' }} />
            );
        default:
            return '';
    }
}

const FilerHeaderBreadcrumbs = (props: Props) => {

    const linkFilerHome = () => {
        props.linkFilerHome();
    }

    const linkLetterEditor = () => {
        props.linkLetterEditor();
    }

    const linkIssueEditor = () => {
        props.linkIssueEditor();
    }

    const linkFilerResponses = () => {
        props.linkFilerResponses();
    }

    const linkFilerRefundTracker = () => {
        props.linkFilerRefundTracker();
    }

    const displayPath = (path: Path) => {
        switch (path.type) {
            case 'name':
                return (<Link key={path.type} underline="hover" color="inherit" onClick={linkFilerHome}>
                    <Typography sx={{ color: blue[500], fontWeight: 'bold'}}>{path.name}</Typography>
                </Link>)
            case 'responses':
                return (<Link key={path.type} underline="hover" color="inherit" onClick={linkFilerResponses}>
                    <Typography sx={{ fontWeight: 'bold' }}>{path.name}</Typography>
                </Link>)
            case 'tracker':
                return (<Link key={path.type} underline="hover" color="inherit" onClick={linkFilerRefundTracker}>
                    <Typography sx={{ fontWeight: 'bold' }}>{path.name}</Typography>
                </Link>)
            case 'letter':
                return (<Link
                    key={path.type}
                    underline="hover"
                    color="text.primary"
                    onClick={linkLetterEditor}
                    sx={{display:'flex'}}
                >
                    {displayLetterStatusIcon(path.status)}
                    <Typography variant="body2" sx={{marginLeft:1}} >{path.name}</Typography>
                </Link>);
            case 'issue':
                return (<Link
                    key={path.type}
                    underline="hover"
                    color="text.primary"
                    onClick={linkIssueEditor}
                    sx={{ display: 'flex' }}
                >
                    {displayIssueStatusIcon(path.status)}
                    <Typography variant="body2" sx={{ marginLeft: 1 }} className={path.status}>{path.name}</Typography>
                </Link>)
        }
    }

    return (<>
        <div>
            <Breadcrumbs
                separator={<NavigateNext fontSize="small" />}
                aria-label="breadcrumb"
            > {
                    props.paths.map((path) => displayPath(path))
              }
            </Breadcrumbs>
        </div>
    </>)
}

export default FilerHeaderBreadcrumbs

